export default __webpack_public_path__ + "static/media/cover1.a1f32b86.png";